const baseUrl = window.location.host;

export async function handleResponse(response) {
  switch (true) {
    case response.status === 401:
      return false;
    case response.status === 403:
      handle403();
      return false;
    case response.ok:
      return true;
    default:
      return false;
  }
}

async function handle403(response) {
  window.location = `https://${baseUrl}/Error/AccessDenied`;
  return true;
}
